/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RoomsDeviceResponseDto = {
  serialNumber: string;
  type: string;
  status: RoomsDeviceResponseDto.status;
};
export namespace RoomsDeviceResponseDto {
  export enum status {
    NEW = 'NEW',
    NEW_IN_PROGRESS = 'NEW_IN_PROGRESS',
    ACTIVE = 'ACTIVE',
    ACTIVATION_IN_PROGRESS = 'ACTIVATION_IN_PROGRESS',
    DEACTIVATED = 'DEACTIVATED',
    DEACTIVATE_IN_PROGRESS = 'DEACTIVATE_IN_PROGRESS',
    SUSPENDED = 'SUSPENDED',
    SUSPEND_IN_PROGRESS = 'SUSPEND_IN_PROGRESS',
    FOR_RETURN = 'FOR_RETURN',
    FOR_RETURN_IN_PROGRESS = 'FOR_RETURN_IN_PROGRESS',
    RESET = 'RESET',
    RESET_IN_PROGRESS = 'RESET_IN_PROGRESS',
  }
}

